<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" @submit.native.prevent>
            <el-form-item label="名称">
              <el-input v-model="searchForm.name" clearable placeholder="关键字搜索" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="addTrainTem">添加培训</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col v-loading="loading" :span="24">
                <el-table
                  :data="trainList"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="dName"
                    label="培训名称"
                    align="left"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    label="培训地址"
                    align="left"
                    width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <i class="el-icon-location-information"></i>
                      <span>{{ scope.row.dAddress }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="270"
                    label="截止日期"
                    align="center">
                    <template slot-scope="scope">
                      <i class="el-icon-time"></i>
                      <span>{{scope.row.dStarttime}} ~ {{scope.row.dEndtime}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="dTime"
                    label="添加时间"
                    align="center"
                    width="200"
                    show-overflow-tooltip/>
                  <el-table-column
                    label="指派类型"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.dAssign===0" :disable-transitions="true" size="mini" type="info">不指派</el-tag>
                      <el-tag v-if="scope.row.dAssign===1" :disable-transitions="true" size="mini">全员</el-tag>
                      <el-tag v-if="scope.row.dAssign===2" :disable-transitions="true" size="mini" type="danger">指定人员</el-tag>
                      <el-tag v-if="scope.row.dAssign===3" :disable-transitions="true" size="mini" type="warning">部门</el-tag>
                      <el-tag v-if="scope.row.dAssign===4" :disable-transitions="true" size="mini" type="success">职位</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="应学人数"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #f56c6c;font-weight: bold;margin-left: 10px"><i class="el-icon-user-solid"></i> {{scope.row.dShould}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="已学人数"
                    align="center"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="color: #67C23A;font-weight: bold;margin-left: 10px"><i class="el-icon-success"></i> {{scope.row.dAlready}}</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                    prop="username"-->
<!--                    label="指派人"-->
<!--                    align="center"-->
<!--                    width="100"-->
<!--                    fixed="right"-->
<!--                    show-overflow-tooltip/>-->
                  <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    width="300">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-edit" size="mini" @click="editTrainTem(scope.row)">修改</el-button>
                      <el-button icon="el-icon-delete" size="mini" @click="deleteTrainTem(scope.row)">删除</el-button>
                      <el-button icon="el-icon-document" size="mini" @click="row=scope.row;showTrain(scope.row)">预览</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      :loading="dialogLoading">
      <el-row>
        <el-col :span="24">
          <el-form ref="addForm" :model="addForm" :rules="rules" label-position="right" label-width="100px" size="small">
            <el-form-item label="培训名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入培训名称" clearable maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="选择时间" prop="timeArray">
              <el-date-picker
                v-model="addForm.timeArray"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="培训地址" prop="address">
              <el-input v-model="addForm.address" placeholder="请输入地址" clearable maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="指派类型" prop="dAssign">
              <el-radio v-model="addForm.assign" :label="0">不指派</el-radio>
              <el-radio v-model="addForm.assign" :label="1">全员</el-radio>
              <el-radio v-model="addForm.assign" :label="2">指定人员</el-radio>
              <el-radio v-model="addForm.assign" :label="3">部门</el-radio>
              <el-radio v-model="addForm.assign" :label="4">职位</el-radio>
            </el-form-item>
            <el-form-item v-if="addForm.assign===2" label="指定人员" prop="useridData">
              <el-cascader
                v-model="addForm.useridData"
                style="width: 100%"
                :options="deptEmployeeTree"
                :props="{multiple: true}"
                placeholder="点击选择人员"
                :show-all-levels="false"
                filterable
                clearable/>
            </el-form-item>
            <el-form-item v-if="addForm.assign===3" label="指派部门" prop="deptidData">
              <el-cascader
                ref="deptSelect"
                v-model="addForm.deptidData"
                style="width: 100%"
                :options="deptTree"
                :props="{multiple: true}"
                placeholder="点击选择部门"
                filterable
                clearable/>
            </el-form-item>
            <el-form-item v-if="addForm.assign===4" label="指派职位" prop="positionidData">
              <el-cascader
                v-model="addForm.positionidData"
                style="width: 100%"
                :options="positionTree"
                :props="{multiple: true}"
                :show-all-levels="false"
                placeholder="点击选择职位"
                filterable
                clearable/>
            </el-form-item>
            <el-form-item label="签到场次" prop="trainCheck" :rules="{required: true, message: '请选择签到场次'}">
              <el-form-item
                v-for="(check, index) in addForm.trainCheck"
                v-model="addForm.trainCheck[index]">
                <el-row :span="24">
                  <el-col :span="6" style="margin-right: 50px">
                    <el-form-item
                      :prop="'trainCheck.'+index+'.time'"
                      :rules="{required: true, message: '请选择签到时间', trigger: 'blur'}">
                      <el-date-picker
                        v-model="check.time"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" style="margin-right: 10px">
                    <el-form-item
                      :prop="'trainCheck.'+index+'.name'"
                      :rules="{required: true, message: '请输入签到名称', trigger: 'blur'}">
                      <el-input
                        v-model="check.name"
                        placeholder="请输入签到名称"
                        clearable
                        maxlength="20"
                        show-word-limit/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2">
                    <i v-if="index < 1" class="el-icon-plus" style="color: #4b9af8" @click="addCheck"/>
                    <i v-if="index >= 1" class="el-icon-delete" style="color: #4b9af8" @click="deleteCheck(index)"/>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form-item>
            <el-form-item label="工作人员">
              <el-form-item
                v-for="(staff, index) in addForm.staffList"
                v-model="addForm.staffList[index]">
                <el-row :span="24">
                  <el-col :span="7" style="margin-right: 18px">
                    <el-cascader
                      v-model="staff.userid"
                      style="width: 100%"
                      :options="deptEmployeeTree"
                      :show-all-levels="false"
                      :prop="'staffList.'+index+'.userid'"
                      :rules="{required: true, message: '请选择工作人员', trigger: 'change'}"
                      placeholder="点击选择工作人员"
                      filterable
                      clearable/>
                  </el-col>
                  <el-col :span="10" style="margin-right: 10px">
                    <el-input v-model="staff.res" :prop="'staffList.'+index+'.res'" :rules="{required: true, message: '请输入负责事宜', trigger: 'blur'}" placeholder="请输入负责事宜" clearable maxlength="20" show-word-limit/>
                  </el-col>
                  <el-col :span="2">
                    <i v-if="index < 1" class="el-icon-plus" style="color: #4b9af8" @click="addStaff"/>
                    <i v-if="index >= 1" class="el-icon-delete" style="color: #4b9af8" @click="deleteStaff(index)"/>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form-item>
            <el-form-item label="培训介绍" prop="intro">
              <Tinymce v-if="dialogVisible" v-model="addForm.intro"/>
            </el-form-item>
            <el-form-item style="text-align: right;">
              <el-button type="primary" :loading="btnLoading" @click="submitTrainTem">立即提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="预览培训情况"
      :visible.sync="showVisible"
      width="60%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-row>
        <el-col>
          <div>
            <el-form :inline="true" size="small" @submit.native.prevent>
              <el-form-item label="姓名">
                <el-input v-model="showForm.name" clearable placeholder="关键字搜索" @keyup.enter.native="showSearch" />
              </el-form-item>
              <el-form-item>
                <el-button icon="el-icon-search" @click="showSearch">搜索</el-button>
              </el-form-item>
            </el-form>
            <div class="card-content">
              <el-row>
                <el-col :span="24">
                  <el-table
                    :data="showTrainList"
                    stripestyle="width: 100%">
                    <el-table-column
                      prop="name"
                      label="培训用户"
                      width="100"
                      align="center"
                      show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                      prop="dataName"
                      label="培训名称"
                      min-width="200"
                      align="left"
                      show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                      label="学习结果"
                      width="100"
                      align="center"
                      show-overflow-tooltip>
                      <template slot-scope="scope">
                        <el-tag v-if="scope.row.res===0" size="mini" type="danger">未学</el-tag>
                        <el-tag v-if="scope.row.res===1" size="mini" type="success">已学</el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      align="center"
                      width="200">
                      <template slot-scope="scope">
                        <el-button icon="el-icon-search" size="mini" @click="recordRow=scope.row;showTrainRecord(scope.row)">查看详情</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    v-if="showTotal>0"
                    background
                    :current-page="showCurrentPage"
                    :page-sizes="[10, 50, 100]"
                    :page-size="showPageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="showTotal"
                    @size-change="showHandleSizeChange"
                    @current-change="showHandleCurrentChange"/>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      title="签到详情"
      :visible.sync="recordVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div>
        <el-row>
          <el-col :span="24">
            <el-table
              :data="trainRecordList"
              style="width: 100%">
              <el-table-column
                label="签到名称"
                prop="dName"
                align="left"
                min-width="200px">
              </el-table-column>
              <el-table-column
                label="签到时间"
                align="center"
                min-width="200px">
                <template slot-scope="scope">
                  <span v-if="scope.row.sign_time!==null && scope.row.sign_time!=='' && scope.row.sign_time!==undefined">{{ scope.row.sign_time }}</span>
                  <el-tag type="danger" size="mini" v-if="scope.row.sign_time===null || scope.row.sign_time==='' || scope.row.sign_time===undefined">未签</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="应签时间"
                prop="dTime"
                align="center"
                width="200px">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import Tinymce from '@/components/Tinymce/index'
import {
  addOrEditTrainGxj,
  deleteTrainGxj, getShowTrainList,
  getStaffListById, getTrainAssignData,
  getTrainCheckById,
  getTrainListGxj, getTrainRecord
} from '@/api/train'
import { getDeptEmployeeTree, getDeptTree } from '@/api/work'
import { getPositionTree } from '@/api/pub'
import qs from 'qs'

export default {
  name: 'xxpx',
  components: {
    Tinymce
  },
  data() {
    return {
      searchForm: {
        name: ''
      },
      deptEmployeeTree: [],
      positionTree: [],
      deptTree: [],
      dialogTitle: '',
      loading: false,
      dialogVisible: false,
      dialogLoading: false,
      btnLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      trainList: [],
      addForm: {
        useridData: [],
        deptidData: [],
        positionidData: [],
        staffList: [{
          userid: [],
          res: ''
        }],
        trainCheck: [{
          time: '',
          name: ''
        }],
        tid: 0,
        name: '',
        timeArray: [],
        assign: 0,
        intro: '',
        userid: 0,
        address: ''
      },
      rules: {
        name: [{ required: true, message: '请输入培训名称', trigger: 'blur' }],
        timeArray: [{ required: true, message: '请选择起止时间', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        intro: [{ required: true, message: '请输入培训介绍', trigger: 'blur' }],
        useridData: [{ required: true, message: '请选择指定人员', trigger: 'change' }],
        deptidData: [{ required: true, message: '请选择指派部门', trigger: 'change' }],
        positionidData: [{ required: true, message: '请选择指派职位', trigger: 'change' }]
      },
      showTrainList: [],
      trainRecordList: [],
      showTotal: 0,
      showPageSize: 10,
      showCurrentPage: 1,
      showVisible: false,
      recordVisible: false,
      showForm: {
        name: ''
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    this.selectDeptEmployeeTree()
    this.selectPositionTree()
    this.selectDeptTree()
  },
  methods: {
    Search() {
      this.currentPage = 1
      this.getData()
    },
    showSearch() {
      this.showCurrentPage = 1
      this.showTrain(this.row)
    },
    getData() {
      this.loading = true
      const data = {
        userid: this.user.dUserid,
        role: this.user.rank,
        page: this.currentPage,
        limit: this.pageSize,
        name: this.searchForm.name
      }
      getTrainListGxj(data).then(response => {
        this.trainList = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    selectDeptTree() {
      const data = {
        dGroupid: this.user.dGroupid
      }
      getDeptTree(data).then(response => {
        this.deptTree = response.data
      })
    },
    selectPositionTree() {
      getPositionTree().then(response => {
        this.positionTree = response.data
      })
    },
    selectDeptEmployeeTree() {
      const data = {
        dGroupid: this.user.dGroupid
      }
      getDeptEmployeeTree(data).then(response => {
        this.deptEmployeeTree = response.data
      }).catch(() => {})
    },
    addTrainTem() {
      this.addForm.trainCheck = []
      this.addForm.staffList = []
      this.addForm.tid = 0
      this.addForm.name = ''
      this.addForm.timeArray = []
      this.addForm.assign = 0
      this.addForm.intro = ''
      this.addForm.address = ''
      this.addCheck()
      this.addStaff()
      this.dialogTitle = '添加线下培训'
      this.dialogVisible = true
    },
    editTrainTem(row) {
      if (!this.dialogLoading) {
        this.dialogLoading = true
        this.addForm.trainCheck = []
        this.addForm.staffList = []
        this.addForm.tid = row.dTid
        this.addForm.name = row.dName
        this.addForm.timeArray = []
        this.addForm.timeArray[0] = row.dStarttime
        this.addForm.timeArray[1] = row.dEndtime
        this.addForm.assign = row.dAssign
        this.addForm.intro = row.dIntro
        this.addForm.address = row.dAddress
        this.dialogTitle = '修改线下培训'
        this.dialogVisible = true
        this.getTrainCheck(row.dTid)
        this.getStaffList(row.dTid)
        if (row.dAssign === 2 || row.dAssign === 3 || row.dAssign === 4) {
          const data = {
            dGroupid: this.user.dGroupid,
            tid: row.dTid,
            assign: row.dAssign
          }
          getTrainAssignData(data).then(response => {
            if (row.dAssign === 2) {
              this.addForm.useridData = response.data
              this.addForm.deptidData = []
              this.addForm.positionidData = []
            } else if (row.dAssign === 3) {
              this.editForm.deptidData = response.data
              this.editForm.useridData = []
              this.editForm.positionidData = []
            } else if (row.dAssign === 4) {
              this.editForm.positionidData = response.data
              this.editForm.deptidData = []
              this.editForm.useridData = []
            }
            this.dialogLoading = false
          })
        }
        this.dialogLoading = false
      }
    },
    showTrain(row) {
      this.showStudyList = []
      const data = {
        name: this.showForm.name,
        tid: row.dTid,
        page: this.showCurrentPage,
        limit: this.showPageSize,
        dataName: row.dName
      }
      getShowTrainList(data).then(response => {
        this.showTrainList = response.data
        this.showTotal = response.total
      })
      this.showVisible = true
    },
    showTrainRecord(row) {
      this.trainRecordList = []
      const data = {
        tid: row.tid,
        userid: row.userid,
        role: row.role
      }
      getTrainRecord(data).then(response => {
        this.trainRecordList = response.data
      })
      this.recordVisible = true
    },
    getTrainCheck(dTid) {
      getTrainCheckById({ tid: dTid }).then(response => {
        for (const check of response.data) {
          this.addForm.trainCheck.push({
            name: check.dName,
            time: check.dTime
          })
        }
      })
    },
    getStaffList(dTid) {
      getStaffListById({ tid: dTid }).then(response => {
        for (const staff of response.data) {
          this.addForm.staffList.push({
            userid: staff.ids,
            res: staff.dRes
          })
        }
        if (this.addForm.staffList.length === 0) {
          this.addStaff()
        }
      })
    },
    deleteTrainTem(row) {
      this.$confirm('您确定要删除此线下培训吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        deleteTrainGxj({ tid: row.dTid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    submitTrainTem() {
      if (!this.btnLoading) {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            const _useridData = []
            const _deptidData = []
            const _positionidData = []
            const _staffList = []
            if (this.addForm.assign === 2) {
              for (const userlst of this.addForm.useridData) {
                for (const user of userlst) {
                  if (user.indexOf('user@') >= 0) {
                    _useridData.push(user.split('@')[1])
                  }
                }
              }
            } else if (this.addForm.assign === 3) {
              for (const d of this.$refs.deptSelect.getCheckedNodes()) {
                _deptidData.push(d.value.split('@')[1])
              }
            } else if (this.addForm.assign === 4) {
              for (const poslst of this.addForm.positionidData) {
                if (poslst.length === 3) {
                  _positionidData.push(poslst[2])
                }
              }
            }
            for (const staff of this.addForm.staffList) {
              if (staff.userid.length !== 0 && staff.res !== '' && staff.res !== null && staff.res !== undefined) {
                if (staff.userid[1].indexOf('user@') >= 0) {
                  _staffList.push({
                    userid: staff.userid[1].split('@')[1],
                    res: staff.res
                  })
                }
              }
            }
            const data = {
              useridData: _useridData.join(','),
              deptidData: _deptidData.join(','),
              positionidData: _positionidData.join(','),
              staffList: qs.parse(_staffList),
              tid: this.addForm.tid,
              trainCheck: qs.parse(this.addForm.trainCheck),
              name: this.addForm.name,
              starttime: this.addForm.timeArray[0],
              endtime: this.addForm.timeArray[1],
              intro: this.addForm.intro,
              userid: this.user.dUserid,
              groupid: this.user.dGroupid,
              role: this.user.rank,
              address: this.addForm.address,
              assign: this.addForm.assign
            }
            this.btnLoading = true
            addOrEditTrainGxj(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.btnLoading = false
              this.dialogVisible = false
              this.getData()
            }).catch(() => {
              this.btnLoading = false
            })
          } else {
            return false
          }
        })
      }
    },
    addStaff() {
      this.addForm.staffList.push({
        userid: [],
        res: ''
      })
    },
    addCheck() {
      this.addForm.trainCheck.push({
        time: '',
        name: ''
      })
    },
    deleteStaff(index) {
      this.addForm.staffList.splice(index, 1)
    },
    deleteCheck(index) {
      this.addForm.trainCheck.splice(index, 1)
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    showHandleSizeChange(val) {
      this.showPageSize = val
      this.showCurrentPage = 1
      this.showTrain(this.row)
    },
    showHandleCurrentChange(val) {
      this.showCurrentPage = val
      this.showTrain(this.row)
    }
  }
}
</script>

<style scoped>

</style>
